export default {
  en: {
    memberWindow: 'Member Login',
    noAccount: 'No account?',
    signUpNow: 'Sign up now',
    customerService: 'Customer Service',
    forgotPassword: 'Forgot password?'
  },
  'zh-CN': {
    memberWindow: '会员登录',
    noAccount: '没有账号？',
    signUpNow: '立即注册',
    customerService: '客服中心',
    forgotPassword: '忘记密码？'
  },
  vi: {
    memberWindow: 'Đăng nhập thành viên',
    noAccount: 'Chưa có tài khoản?',
    signUpNow: 'Đăng ký ngay',
    customerService: 'Chăm sóc khách hàng',
    forgotPassword: 'Quên mật khẩu?'
  },
  hi: {
    memberWindow: 'सदस्य लॉगिन',
    noAccount: 'खाता नहीं है?',
    signUpNow: 'अभी साइन अप करें',
    customerService: 'ग्राहक सेवा',
    forgotPassword: 'पासवर्ड भूल गए?'
  },
  th: {
    memberWindow: 'เข้าสู่ระบบสมาชิก',
    noAccount: 'ยังไม่มีบัญชี?',
    signUpNow: 'สมัครตอนนี้',
    customerService: 'ฝ่ายบริการลูกค้า',
    forgotPassword: 'ลืมรหัสผ่าน?'
  },
  ru: {
    memberWindow: 'Вход для участников',
    noAccount: 'Нет аккаунта?',
    signUpNow: 'Зарегистрироваться',
    customerService: 'Служба поддержки',
    forgotPassword: 'Забыли пароль?'
  },
  ko: {
    memberWindow: '회원 로그인',
    noAccount: '계정이 없나요?',
    signUpNow: '지금 가입',
    customerService: '고객센터',
    forgotPassword: '비밀번호를 잊으셨나요?'
  },
  jp: {
    memberWindow: '会員ログイン',
    noAccount: 'アカウントをお持ちでないですか？',
    signUpNow: '今すぐ登録',
    customerService: 'カスタマーサービス',
    forgotPassword: 'パスワードを忘れた場合'
  },
  es: {
    memberWindow: 'Acceso de miembros',
    noAccount: '¿No tienes cuenta?',
    signUpNow: 'Regístrate ahora',
    customerService: 'Atención al cliente',
    forgotPassword: '¿Olvidaste tu contraseña?'
  },
  fr: {
    memberWindow: 'Connexion membre',
    noAccount: 'Pas de compte ?',
    signUpNow: 'Inscrivez-vous',
    customerService: 'Service client',
    forgotPassword: 'Mot de passe oublié ?'
  },
  de: {
    memberWindow: 'Mitglieder-Login',
    noAccount: 'Noch kein Konto?',
    signUpNow: 'Jetzt registrieren',
    customerService: 'Kundenservice',
    forgotPassword: 'Passwort vergessen?'
  },
  it: {
    memberWindow: 'Accesso membri',
    noAccount: 'Non hai un account?',
    signUpNow: 'Registrati ora',
    customerService: 'Servizio clienti',
    forgotPassword: 'Password dimenticata?'
  }
}
